<!--
DdPortalPartsFunctionList
-->
<template>
<div>
  <div v-if="!userSettings || userSettings.oftenMenuFlg">
    <v-card style="border-radius:10px">
      <v-card-text class="mb-1">
        <v-row no-gutters class="mx-3">
          <v-col :cols="11">
            <div class="mt-5 px-2">
              <span style="color: #000000;font-size:X-large;font-weight:bold;">よく使う機能</span>
            </div>
          </v-col>
          <v-col :cols="1" class="mt-4">
            <span style="float: right;">
              <dd-transparent-button :minWidth="20" @click="isHide = !isHide">
              <div v-if="!isHide" class="condition-expansion"><v-icon>mdi-chevron-up</v-icon></div>
              <div v-else class="condition-expansion"><v-icon>mdi-chevron-down</v-icon></div>
              </dd-transparent-button>
            </span>
          </v-col>
        </v-row>
        <div v-show="isHide" class="pb-2" />
        <div v-show="!isHide">
          <v-row no-gutters>
            <v-col :cols="12" class="px-5">
            <hr
              style="padding-top: 0px !important; padding-bottom: 0px !important; margin-top: 4px !important; margin-bottom: 0px !important;"
              color="#00ffdd"
            >
            </v-col>
          </v-row>
          <v-row no-gutters class="px-3">
            <v-col
              :cols="3"
              class="pa-1"
              v-for="oftenUseMenu in oftenUseMenuList"
              :key="oftenUseMenu.id"
            >
              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <v-card>
                    <v-card-title class="card-title">
                      <v-icon color="primary">{{ oftenUseMenu.icon }}</v-icon>
                      <b>{{ oftenUseMenu.menuNm }}</b>
                    </v-card-title>
                    <v-card-text>
                      <v-row
                        no-gutters
                        v-for="sub in oftenUseMenu.lists"
                        :key="sub.id"
                      >
                        <v-col :cols="12" :sm="12" :xs="6" class="px-1">
                          <v-row no-gutters>
                            <v-col :cols="11">
                              <v-icon>mdi-square-small</v-icon>
                              <router-link v-if="sub.viewNm !== 'ttg-rco-sagyo-edit'" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}">{{ sub.kinoTitle }}</router-link>
                              <router-link v-if="sub.viewNm === 'ttg-rco-sagyo-edit'" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0, backactionno: 4 }}">{{ sub.kinoTitle }}</router-link>
                              <v-icon class="new-icon" color="green" v-if="sub.updDate >= newIconTargetYmd">mdi-new-box</v-icon>
                            </v-col>
                            <v-col :cols="1">
                              <v-row justify="end">
                                <router-link v-if="sub.viewNm === 'ttg-rco-sagyo-edit'" class="pr-3 no-under-line" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0, backactionno: 4 }}" target="_blank">
                                  <dd-icon-button-with-tooltip message="別ウィンドウで開きます" icon="mdi-open-in-new" />
                                </router-link>
                                <router-link v-else class="pr-3 no-under-line" @click.native="onRoute()" :to="{ name: sub.viewNm, params: { id: 0 }}" target="_blank">
                                  <dd-icon-button-with-tooltip message="別ウィンドウで開きます" icon="mdi-open-in-new" />
                                </router-link>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <div class="mx-5 px-5 mb-1">※その他使用できる機能は左のメニューまたはページ上部の[機能一覧]から遷移できます。</div>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</div>
</template>

<script>
// ************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdTransparentButton from '@/components/DdTransparentButton'

// import controls from '@/rahmen/controls'
import flowMixin from '@/mixins/flowMixins'
import date from '@/ddv2.library/date'

import { mapGetters } from 'vuex'

export default {
  name: 'DdPpFunctionList',
  mixins: [flowMixin],
  components: {
    DdIconButtonWithTooltip,
    DdTransparentButton
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean
  },
  data: () => ({
    isHide: false,
    newIconTargetYmd: null
  }),
  created () {
  },
  mounted () {
    // NewIcon制御用日付
    this.newIconTargetYmd = date.getAnyDate(-14)
  },
  computed: {
    ...mapGetters({
      menuList: 'DDMasters/menuList',
      userSettings: 'DDMasters/mstUserSettings'
    }),
    oftenUseMenuList () {
      return this.menuList.filter((t) => {
        return t.oftenUseFlg === true
      })
    }
  },
  methods: {
    onRoute: function (e) {
      // this.Effects.loadStart()
      this.$emit('cancelClose', undefined)
    }
  }
}
</script>
<style scoped>
.text-h5 {
    padding: .1em .5em;
    margin-top: 6px;
    border-left: 6px solid rgb(47, 117, 181);
}
.no-under-line /deep/ {
    text-decoration: none;
}
.menu-description {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.card-title {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 4px;
  padding-right: 4px;
  background-color: rgb(165, 214, 240);
}
</style>
